import React, { useEffect, useState } from 'react';
import {
    Box, Button, Typography, TextField, FormControl, Select, MenuItem, InputLabel,
    Paper, Tooltip, Stack,
    IconButton, Snackbar, Alert, Pagination
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { CircularProgress } from '@mui/material';
import { Edit, DeleteOutline } from '@mui/icons-material';
import RightDrawer from '../components/RightDrawer';
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import dayjs from 'dayjs';
import { GET_LIST, SAVE, GET_LISTBYID, UPDATE, DELETE_DATA } from '../utils/api';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import DeleteConfirmationDialog from '../components/DeleteConfirmationDialog';

const ticketTypes = ['Bug', 'Feature Request', 'General'];
const priorities = ['Low', 'Medium', 'High'];
const statuses = ['Open', 'In Progress', 'Resolved', 'Closed'];

const TicketManagement = ({ role }) => {
    // const [tickets, setTickets] = useState(mockTickets);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [form, setForm] = useState({
        type: '',
        priority: '',
        subject: '',
        description: '',
        attachment: null,
        clientName: ''
    });
    const [tickets, setTickets] = useState([]);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('id');
    const [selected, setSelected] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [alert, setAlert] = useState({ type: '', message: '', open: false });
    const [drawerOpen2, setDrawerOpen2] = useState(false);
    const [editId, setEditId] = useState(null);
    const [selectedId, setSelectedId] = useState(null);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [totalPages, setTotalPages] = useState(0);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const { logout } = useAuth();
    const navigate = useNavigate();




    const fetchTickets = async (searchText = '') => {
        setLoading(true);
        try {
            let queryParams = {
                ...(searchText ? { searchText } : {}),
                limit: limit
            };
            const response = await GET_LIST('/ticket-management', queryParams);
            if (response.statusCode == 401) {
                logout();
                navigate('/login');
            }
            setTickets(response.data);
            setTotalPages(response.data.totalPages)
            setError(null);
        } catch (err) {
            console.error('Failed to fetch users:', err);
            setError('Error loading users');
        } finally {
            setLoading(false);
        }
    };

    const columns = [{
        field: 'id',
        headerName: 'Ticket ID',
        flex: 1,
        sortable: true,
    },
    {
        field: 'subject',
        headerName: 'Subject',
        flex: 2,
        sortable: true,
    },
    {
        field: 'status',
        headerName: 'Status',
        flex: 1,
        sortable: true,
    },
    {
        field: 'priority',
        headerName: 'Priority',
        flex: 1,
        sortable: true,
    },
    {
        field: 'date',
        headerName: 'Created Date',
        flex: 1.5,
        sortable: true,
    },
    {
        field: 'lastUpdated',
        headerName: 'Last Updated',
        flex: 1.5,
        sortable: true,
    },
    {
        field: 'actions',
        headerName: 'Actions',
        flex: 1,
        sortable: false,
        renderCell: (params) => (
            <>
                <Tooltip title="Edit">
                    <IconButton size="small" onClick={() => handleEditClick2(params.id)}>
                        <Edit fontSize="small" />
                    </IconButton>
                </Tooltip>
            </>
        ),
    },
    ];

    const columns2 = [{
        field: 'id',
        headerName: 'Ticket ID',
        flex: 1,
        sortable: true,
    },
    {
        field: 'subject',
        headerName: 'Subject',
        flex: 2,
        sortable: true,
    },
    {
        field: 'status',
        headerName: 'Status',
        flex: 1,
        sortable: true,
    },
    {
        field: 'priority',
        headerName: 'Priority',
        flex: 1,
        sortable: true,
    },
    {
        field: 'date',
        headerName: 'Created Date',
        flex: 1.5,
        sortable: true,
    },
    {
        field: 'lastUpdated',
        headerName: 'Last Updated',
        flex: 1.5,
        sortable: true,
    },
    {
        field: 'actions',
        headerName: 'Actions',
        flex: 1,
        sortable: false,
        renderCell: (params) => (
            <>
                <Tooltip title="Edit">
                    <IconButton size="small" onClick={() => {
                        handleEditClick(params.id);

                    }}>
                        <Edit fontSize="small" />
                    </IconButton>
                </Tooltip>
                <Tooltip title="Delete">
                    <IconButton
                        size="small"
                        sx={{ color: 'red' }}
                        onClick={(e) => {
                            e.stopPropagation();
                            handleOpenDeleteDialog(params.id);
                        }}
                    >
                        <DeleteOutline fontSize="small" />
                    </IconButton>
                </Tooltip>
            </>
        ),
    },
    ];

    useEffect(() => {
        fetchTickets(searchText)
    }, []);

    const [editTicket, setEditTicket] = useState(null);

    const handleEditClick2 = async (id) => {
        try {
            const response = await GET_LISTBYID('/ticket-management', id);
            setEditId(response._id)
            setEditTicket(response);
            setDrawerOpen(true);
        } catch (error) {
            console.error('Failed to fetch user for edit:', error);
            setAlert({
                type: 'error',
                message: 'Failed to load user for editing.',
                open: true,
            });
        }
    };

    const handleEditClick = async (id) => {
        try {
            const response = await GET_LISTBYID('/ticket-management', id);
            setEditId(response._id)
            console.log(response);

            setForm({
                type: response.type,
                priority: response.priority,
                subject: response.subject,
                description: response.description,
                clientName: response.clientName
            });

            setDrawerOpen2(true);
        } catch (error) {
            console.error('Failed to fetch user for edit:', error);
            setAlert({
                type: 'error',
                message: 'Failed to load user for editing.',
                open: true,
            });
        }
    };

    const handleOpenDrawer2 = () => setDrawerOpen2(true);
    const handleCloseDrawer2 = () => {
        setDrawerOpen2(false)
        setForm({
            type: '',
            priority: '',
            subject: '',
            description: '',
            attachment: null,
            clientName: ''
        });
        setEditId(null);
    };

    const handleChange = (field, value) => {
        setForm(prev => ({ ...prev, [field]: value }));
    };

    const handleSaveTicket = async () => {
        // Basic validation
        if (!form.type || !form.priority || !form.subject || !form.clientName) {
            setAlert({
                type: 'error',
                message: 'Please fill in all required fields.',
                open: true,
            });
            return;
        }

        // Build the payload
        const payload = {
            subject: form.subject,
            description: form.description || '',
            clientName: form.clientName,
            priority: form.priority,
            type: form.type,
            status: 'open',
            date: new Date().toISOString(),
        };

        try {
            let response;

            if (editId) {
                // Edit mode
                response = await UPDATE(`/ticket-management/${editId}`, payload);
            } else {
                // Add mode
                response = await SAVE('/ticket-management', payload);
            }

            if (response.statusCode == 401) {
                logout();
                navigate('/login');
            }
            if (response?.status === 200 || response?.status === 201) {
                setAlert({
                    type: 'success',
                    message: editId ? 'Ticket updated successfully' : 'Ticket submitted successfully!',
                    open: true,
                });

                setEditId(null);

                // Optional: refresh ticket list
                fetchTickets();

                // Reset form
                setForm({
                    type: '',
                    priority: '',
                    subject: '',
                    description: '',
                    clientName: '',
                });

                setDrawerOpen2(false);
            } else {
                setAlert({
                    type: 'error',
                    message: response?.data?.message || 'Failed to create ticket.',
                    open: true,
                });
            }
            setEditId(null);
        } catch (error) {
            console.error('Error submitting ticket:', error);
            setAlert({
                type: 'error',
                message: 'Something went wrong while submitting the ticket.',
                open: true,
            });
        }
    };

    const handleSaveTicket2 = async () => {
        const payload = {
            subject: editTicket.subject,
            description: editTicket.description || '',
            clientName: editTicket.clientName,
            priority: editTicket.priority,
            type: editTicket.type,
            status: editTicket.status,
            date: editTicket.date,
        };
        try {
            let response;
            response = await UPDATE(`/ticket-management/${editId}`, payload);

            if (response.statusCode == 401) {
                logout();
                navigate('/login');
            }
            if (response?.status === 200 || response?.status === 201) {
                setAlert({
                    type: 'success',
                    message: 'Ticket updated successfully',
                    open: true,
                });

                setEditId(null);

                // Optional: refresh ticket list
                fetchTickets();


                setDrawerOpen(false);
            } else {
                setAlert({
                    type: 'error',
                    message: response?.data?.message || 'Failed to update ticket.',
                    open: true,
                });
            }
            setEditId(null);
        } catch (error) {
            console.error('Error submitting ticket:', error);
            setAlert({
                type: 'error',
                message: 'Something went wrong while submitting the ticket.',
                open: true,
            });
        }
    };

    const handleOpenDeleteDialog = (id) => {
        setSelectedId(id);
        setDeleteDialogOpen(true);
    };

    // Close dialog
    const handleCloseDeleteDialog = () => {
        setSelectedId(null);
        setDeleteDialogOpen(false);
    };

    // Confirm delete
    const handleConfirmDelete = async () => {
        try {
            const response = await DELETE_DATA('/ticket-management', selectedId);
            if (response.status == 500 || response.status == 409 || response.status == 404) {
                setAlert({
                    type: 'error',
                    message: 'Cannot delete Ticket.',
                    open: true,
                });
            } else {
                setAlert({
                    type: 'success',
                    message: 'Ticket deleted successfully.',
                    open: true,
                });
                await fetchTickets(searchText);
            }
        } catch (error) {
            setAlert({
                type: 'error',
                message: 'Failed to delete the user.',
                open: true,
            });
        } finally {
            handleCloseDeleteDialog();
        }
    };

    return (
        <Box>
            <Typography variant="h6" sx={{ color: 'black', fontWeight: 'bold' }}>
                Ticket Management
            </Typography>
            <Typography variant="body2" sx={{ color: 'gray', marginBottom: 1 }}>
                Last Updated: {new Date().toLocaleDateString()}
            </Typography>
            {/* CLIENT UI */}
            {role === 'vendor' && (
                <>
                    <Box display="flex" justifyContent="flex-end" mb={2}>
                        <Button onClick={handleOpenDrawer2}>
                            Support / Raise a Ticket
                        </Button>
                    </Box>

                    <RightDrawer
                        open={drawerOpen2}
                        onClose={handleCloseDrawer2}
                        onSave={handleSaveTicket}
                        title={editId ? "Edit Ticket" : "Submit a Ticket"}
                    >
                        <Stack spacing={2} sx={{ width: '100%' }}>
                            <TextField
                                required
                                fullWidth
                                size="small"
                                label="Client Name"
                                placeholder="Enter Client Name"
                                value={form.clientName}
                                onChange={(e) => handleChange('clientName', e.target.value)}
                            />

                            <FormControl required fullWidth size="small">
                                <InputLabel>Type</InputLabel>
                                <Select
                                    value={form.type}
                                    label="Type"
                                    onChange={(e) => handleChange('type', e.target.value)}
                                >
                                    {ticketTypes.map((type) => (
                                        <MenuItem key={type} value={type}>{type}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <FormControl required fullWidth size="small">
                                <InputLabel>Priority</InputLabel>
                                <Select
                                    value={form.priority}
                                    label="Priority"
                                    onChange={(e) => handleChange('priority', e.target.value)}
                                >
                                    {priorities.map((p) => (
                                        <MenuItem key={p} value={p}>{p}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <TextField
                                required
                                fullWidth
                                size="small"
                                label="Subject"
                                placeholder="Enter subject"
                                value={form.subject}
                                onChange={(e) => handleChange('subject', e.target.value)}
                            />

                            <TextField
                                fullWidth
                                size="small"
                                label="Description"
                                multiline
                                required
                                rows={4}
                                placeholder="Describe your issue (optional)"
                                value={form.description}
                                onChange={(e) => handleChange('description', e.target.value)}
                            />

                            {/* <Button
                                component="label"
                                startIcon={<CloudUploadIcon />}
                            >
                                Upload Attachment
                                <input hidden type="file" onChange={(e) => handleChange('attachment', e.target.files[0])} />
                            </Button> */}
                        </Stack>

                    </RightDrawer>
                    <Paper
                        sx={{
                            width: '100%',
                            mb: 2,
                            borderRadius: 2,
                            overflow: 'hidden',
                        }}
                    >
                        {loading ? (
                            <Box
                                sx={{
                                    height: 'calc(100vh - 190px)',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    py: 4,
                                }}
                            >
                                <CircularProgress size={30} />
                            </Box>
                        ) : (
                            <>
                                <Box sx={{ height: 'calc(100vh - 190px)', width: '100%' }}>
                                    <DataGrid
                                        rows={tickets}
                                        columns={columns2}
                                        checkboxSelection
                                        hideFooterPagination
                                        disableRowSelectionOnClick
                                        sortingOrder={['asc', 'desc']}
                                        getRowClassName={(params) =>
                                            params.indexRelativeToCurrentPage % 2 === 0
                                                ? 'even-row'
                                                : 'odd-row'
                                        }
                                        onRowSelectionModelChange={(selectionModel) => {
                                            const idsArray = Array.from(selectionModel.ids || []);
                                            setSelected(idsArray);
                                        }}
                                        sx={{
                                            '& .MuiDataGrid-columnHeaders': {
                                                backgroundColor: '#f2f2f2',
                                            },
                                            '& .even-row': { backgroundColor: '#f6f6f6' },
                                            '& .odd-row': { backgroundColor: '#ffffff' },
                                            '& .MuiDataGrid-footerContainer': {
                                                minHeight: '0px'
                                            },
                                            border: 'none',
                                        }}
                                    />
                                </Box>
                                <div style={{ display: "flex", justifyContent: "flex-end", padding: "6px" }}>
                                    <Pagination
                                        count={totalPages}
                                        page={page}
                                        color="primary"
                                        onChange={(e, value) => setPage(value)}
                                        shape="rounded"
                                    />
                                </div>
                            </>
                        )}
                    </Paper>
                </>
            )}

            {/* ADMIN UI */}
            {role === 'admin' && (
                <Paper
                    sx={{
                        width: '100%',
                        mb: 2,
                        borderRadius: 2,
                        overflow: 'hidden',
                    }}
                >
                    {loading ? (
                        <Box
                            sx={{
                                height: 'calc(100vh - 190px)',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                py: 4,
                            }}
                        >
                            <CircularProgress size={30} />
                        </Box>
                    ) : (
                        <>
                            <Box sx={{ height: 'calc(100vh - 190px)', width: '100%' }}>
                                <DataGrid
                                    rows={tickets}
                                    columns={columns}
                                    checkboxSelection
                                    hideFooterPagination
                                    disableRowSelectionOnClick
                                    sortingOrder={['asc', 'desc']}
                                    getRowClassName={(params) =>
                                        params.indexRelativeToCurrentPage % 2 === 0
                                            ? 'even-row'
                                            : 'odd-row'
                                    }
                                    onRowSelectionModelChange={(selectionModel) => {
                                        const idsArray = Array.from(selectionModel.ids || []);
                                        setSelected(idsArray);
                                    }}
                                    sx={{
                                        '& .MuiDataGrid-columnHeaders': {
                                            backgroundColor: '#f2f2f2',
                                        },
                                        '& .even-row': { backgroundColor: '#f6f6f6' },
                                        '& .odd-row': { backgroundColor: '#ffffff' },
                                        '& .MuiDataGrid-footerContainer': {
                                            minHeight: '0px'
                                        },
                                        border: 'none',
                                    }}
                                />
                            </Box>
                            <div style={{ display: "flex", justifyContent: "flex-end", padding: "6px" }}>
                                <Pagination
                                    count={totalPages}
                                    page={page}
                                    color="primary"
                                    onChange={(e, value) => setPage(value)}
                                    shape="rounded"
                                />
                            </div>
                        </>
                    )}
                    <RightDrawer
                        open={drawerOpen}
                        onClose={() => setDrawerOpen(false)}
                        title={`Edit Ticket`}
                        onSave={handleSaveTicket2}
                    >
                        {editTicket && (
                            <Stack spacing={2} sx={{ width: '100%' }}>
                                <TextField
                                    label="Subject"
                                    size="small"
                                    fullWidth
                                    required
                                    value={editTicket.subject}
                                    onChange={e => setEditTicket(t => ({ ...t, subject: e.target.value }))}
                                />
                                <TextField
                                    label="Client Name"
                                    size="small"
                                    fullWidth
                                    required
                                    value={editTicket.clientName}
                                    onChange={e => setEditTicket(t => ({ ...t, clientName: e.target.value }))}
                                />
                                <FormControl required fullWidth size="small">
                                    <InputLabel>Priority</InputLabel>
                                    <Select
                                        label="Priority"
                                        value={editTicket.priority}
                                        onChange={e => setEditTicket(t => ({ ...t, priority: e.target.value }))}
                                    >
                                        {priorities.map(p => (
                                            <MenuItem key={p} value={p}>{p}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <FormControl required fullWidth size="small">
                                    <InputLabel>Status</InputLabel>
                                    <Select
                                        label="Status"
                                        value={editTicket.status}
                                        required
                                        onChange={e => setEditTicket(t => ({ ...t, status: e.target.value }))}
                                    >
                                        {statuses.map(s => (
                                            <MenuItem key={s} value={s}>{s}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <TextField
                                    label="Date"
                                    size="small"
                                    type="date"
                                    fullWidth
                                    required
                                    value={editTicket?.date ? dayjs(editTicket.date).format('YYYY-MM-DD') : ''}
                                    onChange={(e) =>
                                        setEditTicket((t) => ({
                                            ...t,
                                            date: dayjs(e.target.value).toISOString(),
                                        }))
                                    }
                                    InputLabelProps={{ shrink: true }}
                                    inputProps={{
                                        min: dayjs().format('YYYY-MM-DD'), // 🚫 disables previous dates
                                    }}
                                />

                            </Stack>
                        )}
                    </RightDrawer>
                </Paper>
            )}


            <Snackbar
                open={alert.open}
                autoHideDuration={4000}
                onClose={() => setAlert({ ...alert, open: false })}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert
                    severity={alert.type}
                    variant="filled"
                    onClose={() => setAlert({ ...alert, open: false })}
                    sx={{ width: '100%' }}
                >
                    {alert.message}
                </Alert>
            </Snackbar>

            <DeleteConfirmationDialog
                open={deleteDialogOpen}
                onClose={handleCloseDeleteDialog}
                onConfirm={handleConfirmDelete}
                title="Delete Ticket"
                message="Are you sure you want to delete this ticket?"
            />


        </Box>
    );
};

export default TicketManagement;
